export function buildUrl() {
  return '/edge_groups';
}
